export default {"src":"/_next/static/media/shield.8524b79c.svg","height":21,"width":18};